import { storageProxy } from './cache'
import { CacheKeys } from '@/enums/cacheEnum'
import { type PhysicalWarehouseListItem } from '@/api/common'

export const warehouseCodeKey = 'warehouse_code'

export const setWarehouseCode = (code: string) => {
  return storageProxy.set(CacheKeys.WAREHOUSE_CODE, code)
}

export const getWarehouseCode = () => {
  return storageProxy.get(CacheKeys.WAREHOUSE_CODE) as string
}

export const clearWarehouseCode = () => {
  return storageProxy.remove(CacheKeys.WAREHOUSE_CODE)
}

export const setPhysicalWarehouseInfo = (info: PhysicalWarehouseListItem) => {
  return storageProxy.set(CacheKeys.PHYSICAL_WAREHOUSE_INFO, info)
}

export const getPhysicalWarehouseInfo = () => {
  return storageProxy.get(CacheKeys.PHYSICAL_WAREHOUSE_INFO)
}

export const clearPhysicalWarehouseInfo = () => {
  return storageProxy.remove(CacheKeys.PHYSICAL_WAREHOUSE_INFO)
}
